// Version française du contenu du portfolio. Structure identique à
// portfolio.js — les deux fichiers doivent rester synchronisés.

export const profile = {
  name: 'Simon El Khoury El Saifi',
  shortName: 'Simon Saifi',
  initials: 'SS',
  role: 'Développeur Full-Stack',
  location: 'Marseille, France',
  email: 'simon.saifi2000@gmail.com',
  phone: '+33 6 22 18 85 23',
  phoneHref: '+33622188523',
  linkedin: 'https://www.linkedin.com/in/simon-el-khoury-el-saifi/',
  github: 'https://github.com/simonsaifi',
  githubHandle: '@simonsaifi',
  cv: 'Simon-Saifi-CV.pdf',
  availability: 'Ouvert aux postes Full-Stack (CDI)',
  typed: [
    'Développeur Full-Stack',
    'React & Spring Boot',
    'Apps web & mobile',
    'Docker & CI/CD',
  ],
  lead:
    "Développeur Full-Stack basé à Marseille, titulaire d'un Master en génie logiciel. " +
    "Je conçois, développe et livre des applications web & mobiles en Agile dans l'écosystème Java, React et PHP — " +
    "je développe actuellement des outils internes utilisés chaque jour par ~350 agents au CCAS de Marseille.",
  spokenLanguages: [
    { name: 'Français', level: 'Courant' },
    { name: 'Anglais', level: 'Courant' },
    { name: 'Arabe', level: 'Langue maternelle' },
  ],
};

export const stats = [
  { value: 350, suffix: '+', label: 'Utilisateurs quotidiens' },
  { value: 15, suffix: '+', label: 'Technologies livrées' },
  { value: 4, suffix: '', label: 'Entreprises & équipes' },
  { value: 3, suffix: '', label: 'Langues parlées' },
];

export const workedWith = [
  'CCAS de Marseille',
  'ATOS',
  'Grand Port Maritime de Marseille',
  'XMSPRO',
  'Université d’Avignon',
];

export const skillGroups = [
  {
    title: 'Langages',
    icon: 'code',
    items: ['Java', 'JavaScript', 'PHP', 'Python', 'SQL', 'C++'],
  },
  {
    title: 'Frameworks & Librairies',
    icon: 'layers',
    items: ['Spring Boot', 'ReactJS', 'Flutter', 'GWT'],
  },
  {
    title: 'DevOps & Outils',
    icon: 'tool',
    items: ['Docker', 'Git', 'Jenkins', 'CircleCI', 'Maven', 'Jira', 'JBOSS'],
  },
  {
    title: 'Pratiques',
    icon: 'flow',
    items: ['Agile / Scrum', 'REST APIs', 'CI/CD', 'Testing'],
  },
];

export const projects = [
  {
    id: 'orbit',
    title: 'Orbit — Un petit chez-nous pour deux',
    org: 'Projet personnel',
    tag: 'PWA · Temps réel',
    featured: true,
    period: 'Juin 2026 – Aujourd’hui',
    image: null,
    cover: { icon: 'heart', from: '#ec4899', to: '#a855f7' },
    summary:
      'Une PWA temps réel pour les couples — statut partagé en direct, nudges, radar de localisation et notifications push, le tout dans une interface ludique de « relationship OS ».',
    problem:
      'Entre les emplois du temps chargés et la distance, difficile pour deux personnes de rester synchronisées. Je voulais une petite app ludique — un petit chez-nous partagé — pour se sentir proches en temps réel.',
    approach:
      'PWA mobile-first installable en React + TypeScript (Vite, Tailwind). Supabase gère le temps réel, l’auth anonyme et Postgres ; deux téléphones s’appairent via un code à 6 caractères. La localisation live tourne sur Leaflet, et les Edge Functions Supabase + Web Push (VAPID) délivrent les notifications même app fermée. Framer Motion anime le tout ; Workbox le rend disponible hors-ligne.',
    result:
      'Une app installable et fonctionnelle : statut partagé en direct (humeur / énergie / faim), nudges temps réel, radar de localisation, chat, souvenirs, questions du jour et compte à rebours des retrouvailles — plus un mode démo sans aucune configuration.',
    tech: ['React', 'TypeScript', 'Vite', 'Tailwind CSS', 'Supabase', 'Framer Motion', 'Leaflet', 'PWA'],
    links: { live: '', code: 'https://github.com/simonsaifi/sophia' },
    privateNote: 'Projet personnel — code sur demande',
  },
  {
    id: 'ccas',
    title: 'Suite d’applications métier internes',
    org: 'CCAS de Marseille',
    tag: 'Full-Stack · Production',
    featured: true,
    period: 'Juin 2025 – Aujourd’hui',
    image: null,
    cover: { icon: 'building', from: '#6366f1', to: '#a855f7' },
    summary:
      'Une suite d’outils métier internes utilisés quotidiennement par ~350 agents pour faire tourner l’établissement.',
    problem:
      'Les équipes du CCAS de Marseille avaient besoin d’outils internes fiables — suivi du courrier, gestion des formations, chatbot et scanner TPE — pour gérer les opérations quotidiennes sans friction.',
    approach:
      'Conception, développement et maintenance des applications de bout en bout, en Agile : analyse des besoins, développement, tests et mise en production. Front-ends PHP et ReactJS/JavaScript adossés à SQL.',
    result:
      'Plusieurs applications (Courrier, Formation, ChatBot, Scanner TPE…) utilisées chaque jour par ~350 agents, fluidifiant les processus de toute l’organisation.',
    tech: ['PHP', 'ReactJS', 'JavaScript', 'SQL', 'Agile'],
    links: { live: '', code: '' },
    privateNote: 'Projet interne / privé',
  },
  {
    id: 'gpmm',
    title: 'Application Web & Mobile GPMM',
    org: 'ATOS',
    tag: 'Web & Mobile · Entreprise',
    featured: true,
    period: 'Sept. 2023 – Juin 2024',
    image: null,
    cover: { icon: 'anchor', from: '#0ea5e9', to: '#6366f1' },
    summary:
      'Une application web & mobile multiplateforme pour le Grand Port Maritime de Marseille, client stratégique d’ATOS.',
    problem:
      'Le Grand Port Maritime de Marseille (GPMM), client stratégique du groupe, avait besoin d’une application web et mobile multiplateforme robuste.',
    approach:
      'Développement des interfaces front-end en Flutter et intégration de web services REST sur un back-end Java / Spring Boot déployé sur JBOSS, au sein d’une équipe Agile avec des jalons fixes.',
    result:
      'Une application de niveau entreprise livrée pour un client portuaire stratégique, dans les délais et conforme aux spécifications.',
    tech: ['Flutter', 'Java', 'Spring Boot', 'REST', 'GWT', 'JBOSS', 'Maven', 'SQL'],
    links: { live: '', code: '' },
    privateNote: 'Projet entreprise / privé',
  },
  {
    id: 'samaflix',
    title: 'SamaFlix — App de streaming Google TV',
    org: 'XMSPRO',
    tag: 'Android · Streaming',
    featured: false,
    period: 'Fév. 2022 – Juil. 2022',
    image: null,
    cover: { icon: 'tv', from: '#ec4899', to: '#a855f7' },
    summary:
      'Un client de streaming (SamaFlix) pour box Google TV, conforme aux standards de la plateforme.',
    problem:
      'Livrer un client de streaming pour box Google TV conforme aux standards de la plateforme et performant sur du matériel TV.',
    approach:
      'Développement de l’application Android en Java, en résolvant des défis complexes de compatibilité et de performance propres au format TV.',
    result:
      'Un client de streaming (SamaFlix) conforme et performant, déployé sur des box Google TV.',
    tech: ['Java', 'Android', 'Maven'],
    links: { live: '', code: '' },
    privateNote: 'Projet client / privé',
  },
  {
    id: 'drowsiness',
    title: 'Reconnaissance faciale & détection de somnolence',
    org: 'Académique — projet de fin d’études',
    tag: 'IA / Vision par ordinateur',
    featured: false,
    period: '2022',
    image: 'img/SeniorFinal.PNG',
    summary:
      'Un système de vision par ordinateur temps réel qui reconnaît les visages et détecte la somnolence du conducteur pour prévenir les accidents.',
    problem:
      'La somnolence au volant cause des accidents — il fallait un système capable de détecter les signes de somnolence en temps réel et d’identifier le conducteur.',
    approach:
      'Pipeline de vision par ordinateur en Python combinant reconnaissance faciale et analyse des yeux/traits du visage pour signaler la somnolence en direct.',
    result:
      'Un prototype fonctionnel de reconnaissance faciale et d’alertes de somnolence en temps réel, réalisé comme projet de fin d’études.',
    tech: ['Python', 'OpenCV', 'AI / ML'],
    links: { live: '', code: 'https://github.com/simonsaifi/Senior-Final' },
    privateNote: '',
  },
  {
    id: 'lecedrus',
    title: 'Le Cedrus — Site de restaurant',
    org: 'Freelance',
    tag: 'Web · En cours',
    featured: false,
    period: '2024',
    image: 'img/LeCedrus.PNG',
    summary:
      'Le site d’un restaurant libanais présentant la carte, l’histoire et l’adresse, avec une couche de contenu Firebase.',
    problem:
      'Un restaurant libanais avait besoin d’une présence en ligne chaleureuse pour présenter sa carte, son histoire et son adresse.',
    approach:
      'Site React responsive avec un back-end Firebase pour le contenu, en soignant un design visuel chaleureux et appétissant.',
    result:
      'Un site en ligne, adapté au mobile, qui met joliment le restaurant en valeur (itérations en cours).',
    tech: ['ReactJS', 'Firebase', 'JavaScript', 'Bootstrap'],
    links: { live: 'https://lecedrus.vercel.app', code: '' },
    privateNote: '',
  },
  {
    id: 'portfolio',
    title: 'Ce portfolio',
    org: 'Personnel',
    tag: 'Web · Open source',
    featured: false,
    period: '2025',
    image: 'img/Portfolio.PNG',
    summary:
      'Un portfolio single-page rapide et animé, construit avec React — le site que vous êtes en train de regarder.',
    problem:
      'Présenter mon travail et mon parcours avec le même niveau de finition que les produits que je construis.',
    approach:
      'Conception et développement d’une single-page app React avec un design system maison, thèmes clair/sombre, animations au scroll et études de cas en modale.',
    result:
      'Un portfolio performant et accessible qui sert aussi de démonstration de savoir-faire front-end.',
    tech: ['ReactJS', 'styled-components', 'Framer Motion'],
    links: { live: 'https://simonsaifi.vercel.app', code: 'https://github.com/simonsaifi/Portfolio' },
    privateNote: '',
  },
];

export const timeline = [
  {
    type: 'work',
    title: 'Développeur Full-Stack',
    org: 'CCAS de Marseille — Marseille, France',
    date: 'Juin 2025 – Aujourd’hui',
    points: [
      'Conception, développement et maintenance d’applications métier internes (PHP, ReactJS, JavaScript, SQL) pour les équipes de l’établissement.',
      'Prise en charge du cycle complet en Agile : analyse des besoins, développement, tests et production.',
      'Applications internes utilisées chaque jour par ~350 agents (Courrier, Formation, ChatBot, Scanner TPE…).',
    ],
  },
  {
    type: 'work',
    title: 'Développeur Full-Stack en alternance',
    org: 'ATOS — Aix-en-Provence, France',
    date: 'Sept. 2023 – Juin 2024',
    points: [
      'Développement d’une application web & mobile pour le Grand Port Maritime de Marseille (GPMM), client stratégique.',
      'Front-ends Flutter + services REST Java / Spring Boot déployés sur JBOSS.',
      'Livraison Agile avec jalons fixes. Stack : Java, Spring Boot, Flutter, Maven, JavaScript, GWT, JBOSS, SQL.',
    ],
  },
  {
    type: 'work',
    title: 'Développeur Android',
    org: 'XMSPRO — Jounieh, Liban',
    date: 'Fév. 2022 – Juil. 2022',
    points: [
      'Développement d’une application de streaming (client SamaFlix) pour box Google TV, conforme aux standards de la plateforme.',
      'Résolution de défis complexes de compatibilité et de performance. Stack : Java, Maven.',
    ],
  },
  {
    type: 'work',
    title: 'Stagiaire informatique',
    org: 'AUL — Jounieh, Liban',
    date: 'Sept. 2021 – Fév. 2022',
    points: [
      'Maintenance et diagnostic des systèmes et serveurs informatiques de l’université.',
      'Administration des connexions réseau et support utilisateurs (routeurs & switchs Cisco).',
    ],
  },
  {
    type: 'education',
    title: 'Master — Ingénierie logicielle pour la société numérique',
    org: 'CERI, Université d’Avignon — France',
    date: '2022 – 2024',
    points: [
      'Cours clés : développement web/mobile full-stack, DevOps, Intelligence Artificielle, gestion de projet numérique.',
      'Vice-Président Projets & Événements — BDE CERI Avignon.',
    ],
  },
  {
    type: 'education',
    title: 'Licence — Informatique',
    org: 'AUL — Jounieh, Liban',
    date: '2018 – 2022',
    points: ['Fondamentaux du développement logiciel, des algorithmes et des structures de données.'],
  },
];
